/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.changeOrder.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
